import React, {Suspense} from 'react'
import {Route, Routes, useParams} from 'react-router-dom'

import {useDispatch, useSelector} from 'react-redux'
import {DEFAULT_ERROR, TIPO_CORSO} from "../../costanti";
import {
    corso_corsiActions,
    giustificativiActions,
    individuoActions,
    notifsActions,
    pianificazioneCalendarioActions,
    tipiAttivitaActions
} from '../../actions/index';

import {pianificazioniActions} from "../../slices/pianificazioniSlice";
import {corsoCorsiActions} from "../../slices/corso_corsiSlice";

import {CorsoDettaglioContainer} from "../CorsoDettaglio/CorsoDettaglioContainer";
import {ErrorComponent, Loading} from "../../components/index";

// Lazy loading
import {
    Calendario,
    Castelletto,
    DettaglioIndividuoContainer,
    Giustificativo,
    MonitoraggioValidazioniContainer,
    Pianificazione,
    Presenze,
    ProfiliOrariFSE,
    ProfiliOrariFSEContainer,
    ProfiliOrariSCR,
    ProfiloSCRContainer,
    RegistroDettaglio,
    RegistroIndividui,
    RegistroMeseSCR,
    SchedaCorso,
    TimbraturaManuale,
    UpdateChoice,
    ValidazioneCorsoContainer
} from "./lazyLoading";
import Esporta from "../Esporta/Esporta";
import { isPwa } from '../../fanctionUtility';


const Corso = () => {

    const corso = useSelector(state => state.corso.corso);
    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);

    const {id} = useParams();

    const dispatch = useDispatch();

    const getLoadDataOfCourse = React.useCallback(() => dispatch(corso_corsiActions.getLoadDataOfCourse()), [dispatch]);
    const initIndividui = React.useCallback(() => dispatch(individuoActions.initIndividui()), [dispatch]);
    const initPianificazioni = React.useCallback(() => dispatch(pianificazioniActions.pianificazioniInit()), [dispatch]);
    const initDocenti = React.useCallback(() => dispatch(individuoActions.initDocenti()), [dispatch]);
    const initAttivitaByTipoCorso = React.useCallback(() => dispatch(tipiAttivitaActions.initAttivitaByTipoCorso()), [dispatch]);
    const initTipiGiustificativi = React.useCallback(() => dispatch(giustificativiActions.initTipiGiustificativi()), [dispatch]);
    const initCorso = React.useCallback(() => dispatch(corsoCorsiActions.initCorso()), [dispatch]);
    const initCustomToolbar = React.useCallback(() => dispatch(pianificazioneCalendarioActions.initCustomToolbar()), [dispatch]);
    const getCorsoStart = React.useCallback((id) => dispatch(corso_corsiActions.getCorsoStart(id)), [dispatch]);
    const notifClear = React.useCallback(() => dispatch(notifsActions.notifClear()), [dispatch]);


    React.useEffect(() => {

        if (id != null) {
            getCorsoStart(id);
        }

        return () => {
            initIndividui();
            initDocenti();
            initPianificazioni();
            initAttivitaByTipoCorso();
            initTipiGiustificativi();
            initCorso();
            notifClear();
            initCustomToolbar();
        }
    }, [
        getCorsoStart,
        id,
        initAttivitaByTipoCorso,
        initCorso,
        initCustomToolbar,
        initDocenti,
        initIndividui,
        initPianificazioni,
        initTipiGiustificativi,
        notifClear
    ]);

    React.useEffect(() => {
        if (corso != null) {
            getLoadDataOfCourse();
        }
    }, [corso, getLoadDataOfCourse]);


    const renderBody = () => {
        if (corso) {
            if (corso.tipoCorso != null && (corso.tipoCorso === TIPO_CORSO.FORMAZIONE || TIPO_CORSO.GARANZIA_GIOVANI || TIPO_CORSO.COFO)) {
                return (
                    <Routes>

                        <Route path={`/pianificazione/inserisci`}
                               element={<Pianificazione/>}/>

                        <Route path={`/profiliorariFSE`}
                               element={<ProfiliOrariFSE/>}/>

                        <Route path={`/profilazioneFSE`}
                               element={<ProfiliOrariFSEContainer/>}/>

                        <Route path={`/profiliorariFSE/dettaglio/:idAnagrafica`}
                               element={<DettaglioIndividuoContainer/>}/>

                        <Route path={`/calendarioFSE`}
                               element={<Calendario/>}/>

                        <Route path={`/calendarioFSE/:idPianificazione/data/:data/aggiorna`}
                               element={<UpdateChoice/>}/>

                        <Route path={`presenze`}
                               element={<Presenze/>}/>

                        <Route path={`/registro`}
                               element={<RegistroIndividui/>}/>

                        <Route path={`/registro/:individuo/dettaglio`}
                               element={<RegistroDettaglio/>}/>

                        <Route path={`/registro/:individuo/dettaglio/ingressomanuale`}
                               element={<TimbraturaManuale/>}/>

                        <Route path={`/registro/:individuo/dettaglio/uscitamanuale`}
                               element={<TimbraturaManuale/>}/>

                        <Route path={`/registro/:individuo/dettaglio/giustificativo/inserisci`}
                               element={<Giustificativo/>}/>

                        <Route path={`/castelletto`}
                               element={<Castelletto/>}/>

                        <Route path={`/esporta`}
                               element={<Esporta/>}/>

                        <Route path={`/validazionecorso`}
                               element={<ValidazioneCorsoContainer/>}/>

                        <Route path={`/monitoraggioValidazione`}
                               element={<MonitoraggioValidazioniContainer/>}/>

                        <Route path={`/schedaCorso`}
                               element={<SchedaCorso/>}/>

                    </Routes>
                )
            } else if (corso.tipoCorso != null && corso.tipoCorso === TIPO_CORSO.SERVIZIO_CIVILE) {
                return (
                    <Routes>
                        <Route path={`/profiliorariSCR`}
                               element={<ProfiliOrariSCR/>}/>

                        <Route path={`/registro/profiloSCR/:idAnagrafica`}
                               element={<ProfiloSCRContainer/>}/>

                        <Route path={`/presenze`}
                               element={<Presenze/>}/>

                        <Route path={`/registro`}
                               element={<RegistroMeseSCR/>}/>

                        <Route path={`/registro/:individuo/dettaglio`}
                               element={<RegistroDettaglio/>}/>

                        <Route path={`/profiliorariSCR/dettaglio/:idAnagrafica`}
                               element={<DettaglioIndividuoContainer/>}/>

                        <Route path={`/registro/:individuo/dettaglio/giustificativo/inserisci`}
                               element={<Giustificativo/>}/>

                        <Route path={`/registro/:individuo/dettaglio/ingressomanuale`}
                               element={<TimbraturaManuale/>}/>

                        <Route path={`/registro/:individuo/dettaglio/uscitamanuale`}
                               element={<TimbraturaManuale/>}/>

                        <Route path={`/calendarioSCR`}
                               element={<Calendario/>}/>

                        <Route path={`/calendarioSCR/:idPianificazione/data/:data/aggiorna`}
                               element={<UpdateChoice/>}/>

                        <Route path={`/monitoraggioValidazione`}
                               element={<MonitoraggioValidazioniContainer/>}/>

                        <Route path={`/schedaCorso`}
                               element={<SchedaCorso/>}/>

                    </Routes>
                )
            } else {
                return null
            }
        } else {
            return (
                <ErrorComponent genericError={DEFAULT_ERROR}/>
            )
        }
    }


    return (
        <div className="animate__animated animate__fadeIn">

            {corso != null && ruoloScelto != null && (
                <>
                    <CorsoDettaglioContainer dati={corso}/>

                    <div className={`w-100 ${isPwa() ? 'my-2' : 'my-5'}`}>
                        <Suspense fallback={<Loading messaggio='Recupero dati...'/>}>
                            {renderBody()}
                        </Suspense>
                    </div>
                </>
            )}

        </div>
    )
}


export default React.memo(Corso);


